//Module Configuration
import {isTrue} from '../utils';
import {Template} from '../models/Template';
import {getEmptyDynamicConfig} from '../utils/DtoUtils';

//General DLS Configuration
export const defaultDynamicConfig = getEmptyDynamicConfig();
export const defaultDlsIsEnabled = isTrue(process.env.REACT_APP_DLS_ENABLED ?? 'false');
export const defaultDlsBackendUrl = process.env.REACT_APP_DXF_DOWNLOAD_BACKEND_URL ?? '';
export const defaultWtmBackendUrl = process.env.REACT_APP_DXF_WATERMARK_BACKEND_URL ?? '';
export const defaultDisclaimerUrl = process.env.REACT_APP_DXF_DISCLAIMER_URL ?? '';
export const defaultLabelUrl = process.env.REACT_APP_DXF_LABEL_URL ?? '';
export const defaultTenant = '';
export const defaultThumbnailUploadMaxSize = 1; //1MB
export const defaultUiConfigurationTemplates = [] as Template[];
export const defaultUiComponentTemplates = [] as Template[];

//UI Styling
export const defaultUiIncludeFrok = isTrue(process.env.REACT_APP_DXF_DOWNLOAD_INCLUDE_FROK ?? 'true');
export const defaultStyleWordBreak = isTrue(process.env.REACT_APP_WORD_BREAK ?? 'true');

//CosmosDB Configuration
export const defaultSpaceName = 'uploads';

export const defaultModuleTemplates = false;
export const defaultModuleSoftwareProduct = false;
export const defaultModuleAudit = false;
export const defaultModuleMalwareScanner = false;

//Authorization Configuration
export const defaultApiTokenPath = '/api/token';
export const defaultUseClientRoles = isTrue(process.env.REACT_APP_DLS_USE_CLIENT_ROLES ?? 'false');
export const defaultRoleLength = process.env.REACT_APP_DXF_ROLE_LENGTH ?? 50;
export const defaultPermissions = [] as string[];
export const defaultAdminRole = 'ROLE_';
export const defaultEditorRole = 'ROLE_';
export const defaultUserRole = 'ROLE_';

//Access Configuration
export const defaultRoleAccessMobileViewAdmin = false;
export const defaultRoleAccessMobileViewEditor = false;
export const defaultRoleAccessMobileViewUser = false;

//Locale Configuration
export const defaultLanguageOnlyMode = false;
export const defaultSwapCountryLanguage = false;
export const defaultCountry = process.env.REACT_APP_DXF_DOWNLOAD_COUNTRY_FALLBACK ?? 'DE';
export const defaultLanguage = process.env.REACT_APP_DXF_DOWNLOAD_LANGUAGE_FALLBACK ?? 'de';
export const defaultCountries = [] as string[];
export const defaultLanguages = [] as string[];
